// import httpClient from "@src/services/http.service";

const state = {
  switches: [],
  error: ''
}

const mutations = {
  SET_SWITCHES: (state, switches) => {
    state.switches = switches
  },
  SET_ERROR: (state, error) => {
    state.error = error
  }
}

const actions = {
  init: (ctx) => {
    // httpClient.get('switch')
    //   .then(({ data }) => {
    //     ctx.commit('SET_SWITCHES', data)
    //   })
    //   .catch(error => {
    //     ctx.commit('SET_ERROR', error.message)
    //   })
  }
}

const getters = {
  isActive: state => title => {
    const switchObj = state.switches.find(obj => obj.title === title)
    if (switchObj) {
      return switchObj.isActive
    } else {
      console.error('switch not found', title)
      return false
    }
  }
}


export default {
  state,
  actions,
  mutations,
  getters
}
